module.exports = require('./helpers/bundle-url').getBundleURL('aHO5m') + "logo.c51670a8.svg";